<template>
  <LcHeader
    v-bind="{ leftButtonIcon }"
    :class="{ 'lottery-header--compact': compact }"
    :fly-out-toggle-aria-label="$t('lottery.header.button.flyout')"
    fly-out-toggle-class="paragraph-bold"
    :with-fly-out="showFlyOut"
    @left-button-click="handleClick"
  >
    <template #fly-out-content>
      <LotteryPriceBreakdown scrollable />
    </template>

    <template #fly-out-toggle>
      {{ chargeTotal }}
    </template>

    <template #headline>
      <slot name="headline">
        <LcLotteryLogo v-bind="{ licensedTerritory, lotteryId }" />
      </slot>
    </template>

    <slot />
  </LcHeader>
</template>

<script lang="ts" setup>
import type { LcHeaderProps } from '@lottocom/frontend-components'

type LotteryHeaderProps = Pick<LcHeaderProps, 'leftButtonIcon' | 'withFlyOut'> & {
  /** matches the editor header height to avoid a jump when navigating from it */
  compact?: boolean
  onClick?: () => void
}

defineOptions({ inheritAttrs: false })

const {
  compact,
  leftButtonIcon = 'arrow-left',
  onClick,
  withFlyOut,
} = defineProps<LotteryHeaderProps>()

const licensedTerritory = useLicensedTerritory({ raw: true })

const { currentPrice, lotteryId } = usePlaySlip()
const { back, chargeTotal, showFlyOut } = usePriceBreakdownHeader(currentPrice, withFlyOut)

const handleClick = () => {
  if (onClick) return onClick()
  back()
}
</script>

<style lang="scss" scoped>
/* stylelint-disable selector-class-pattern */
.lottery-header--compact {
  :deep(.lc-header__wrap) {
    min-height: 4.5rem;
  }

  :deep(.lc-header__fly-out) {
    padding-top: 4.5rem;
  }
}
</style>
